if (!customElements.get("card-slider")) {
  class CardSlider extends HTMLElement {
    constructor() {
      super();
      this.slidesList = this.querySelector(".card-slider__list");
      this.buttons = this.querySelectorAll(".card-slider__button");
      this.paginationItems = this.querySelectorAll(
        ".card-slider__pagination-item"
      );

      this.infoIcon = this.querySelector(".card-slider__info");

      this.mediaWrapper = this.closest(".product-card-media-wrapper");

      this.currentIndex = 0;
      // Set once the visitor drives the slider themselves. The images are lazy,
      // so a `load` can land long after first paint — mid-click, even — and
      // pinToStart's instant scrollTo would cancel the smooth scroll already in
      // flight, eating the click. After the first interaction the slider belongs
      // to the visitor, not to the loader.
      this.userEngaged = false;
      this.markEngaged = () => {
        this.userEngaged = true;
      };

      this.pinToStart();
      this.updateOverlayVisibility();
      this.slidesList.querySelectorAll("img").forEach((img) => {
        if (!img.complete) {
          img.addEventListener("load", () => this.pinToStart(), { once: true });
          img.addEventListener("error", () => this.pinToStart(), { once: true });
        }
      });

      // Manual swipe / wheel / drag counts as engagement too: those reach the
      // slider as plain scroll events, which are indistinguishable from the
      // programmatic ones.
      ["pointerdown", "touchstart", "wheel"].forEach((evt) => {
        this.slidesList.addEventListener(evt, this.markEngaged, {
          passive: true,
        });
      });

      if (this.classList.contains("card-slider--desktop-only")) {
        const mql = window.matchMedia("(min-width: 1024px)");
        const onBreakpointChange = (e) => {
          if (e.matches) this.reinit();
        };
        if (mql.addEventListener) {
          mql.addEventListener("change", onBreakpointChange);
        } else {
          mql.addListener(onBreakpointChange);
        }
      }

      [...this.buttons].forEach((btn) => {
        btn.addEventListener("click", () => {
          this.markEngaged();
          this.scrollList(btn);
          this.highlightPagination();
          this.visibilityBtn();
          this.currentIndexByScroll();
        });
      });

      this.slidesList.addEventListener("scroll", () => {
        this.highlightPagination();
        this.visibilityBtn();
        this.currentIndexByScroll();
      });

      this.paginationItems.forEach((item, index) => {
        item.addEventListener("click", () => {
          this.markEngaged();
          this.slidesList.scrollLeft = this.slideWidth * index;
        });
      });
      // No card currently renders .card-slider__info, so this is usually null —
      // without the guard the constructor throws on every product card and the
      // element is left un-upgraded.
      this.infoIcon?.addEventListener("click", () => {
        this.markEngaged();
        this.slidesList.scrollLeft = this.slideWidth * 1;
        this.currentIndex = 1;
      });
    }

    pinToStart() {
      if (this.userEngaged) return;
      if (this.currentIndex !== 0) return;
      this.slidesList.scrollTo({ left: 0, behavior: "instant" });
    }

    reinit() {
      this.currentIndex = 0;
      this.slidesList.scrollTo({ left: 0, behavior: "instant" });
      this.highlightPagination();
      this.visibilityBtn();
      this.updateOverlayVisibility();
    }

    get slideWidth() {
      const slide = this.querySelector(".card-slider__slide");
      return slide ? slide.clientWidth : 0;
    }

    scrollList(btn) {
      let size = this.slidesList.children.length;
      let listWidth = Math.floor(this.slidesList.scrollWidth);
      let cardWidth = Math.floor(listWidth / size);
      let direction = btn.getAttribute("data-switch-action");

      direction == "next"
        ? (this.slidesList.scrollLeft += cardWidth)
        : (this.slidesList.scrollLeft -= cardWidth);
    }

    visibilityBtn() {
      let size = this.slidesList.children.length;
      let prev = this.buttons[0];
      let next = this.buttons[1];
      this.currentIndex === 0
        ? prev.setAttribute("data-active", "false")
        : prev.setAttribute("data-active", "true");

      this.currentIndex === size - 1
        ? next.setAttribute("data-active", "true")
        : next.setAttribute("data-active", "true");

      this.renderLinkIcon(next, size);
    }

    renderLinkIcon(next, size) {
      const link = this.getAttribute("data-link");
      this.currentIndex === size - 1
        ? (next.innerHTML = `
        <a href="${link}" class="card-slider__link">
          <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          >
          <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
          </svg>
        </a>
        `)
        : (next.innerHTML = `
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              >
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
        `);
    }

    highlightPagination() {
      this.paginationItems.forEach((p) =>
        p.setAttribute("data-active", "false")
      );
      this.paginationItems[this.currentIndex]?.setAttribute(
        "data-active",
        "true"
      );
    }

    currentIndexByScroll() {
      let currentPosition = Math.floor(this.slidesList.scrollLeft);
      const newIndex = Math.round(currentPosition / this.slideWidth);
      if(newIndex != this.currentIndex) {
        fireCustomGA4Event("scroll_product_card_slider");
      }
      this.currentIndex = newIndex;
      this.updateOverlayVisibility();
    }

    updateOverlayVisibility() {
      if (!this.mediaWrapper) return;
      this.mediaWrapper.dataset.beyondFirst = this.currentIndex > 0;
    }
  }

  customElements.define("card-slider", CardSlider);
}
